import { Box, Flex } from '@chakra-ui/react';

import { Shimmer } from 'components/Shimmer';
import { neutral, radius } from 'styles/revampTokens';

/**
 * Shaped like the dashboard it stands in for — title row, pages strip, KPI row,
 * then the widget grid — so the layout does not jump once data arrives.
 *
 * Previously drawn in lilac on a pink-to-violet page wash, which was the
 * pre-revamp palette; placeholders are chrome and belong in the neutral ramp.
 */
const KPI_COUNT = 3;
const PAGE_TAB_COUNT = 3;

const Card = ({ children, ...rest }: any) => (
  <Box
    bg={neutral.surface}
    border={`1px solid ${neutral.border}`}
    borderRadius={radius.surface}
    p='16px'
    {...rest}
  >
    {children}
  </Box>
);

const DashboardSkeletonLoader = () => (
  <Flex direction='column' gap='16px' p='16px' height='100%' width='100%' bg={neutral.canvas}>
    {/* Title + reporting-period pill */}
    <Flex justify='space-between' align='center'>
      <Shimmer height='24px' width='200px' control />
      <Shimmer height='24px' width='140px' control />
    </Flex>

    {/* Pages strip */}
    <Flex gap='8px'>
      {Array.from({ length: PAGE_TAB_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Shimmer key={index} height='32px' width='110px' control />
      ))}
    </Flex>

    {/* KPI row */}
    <Flex gap='16px'>
      {Array.from({ length: KPI_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Card key={index} flex='1'>
          <Shimmer height='9px' width='40%' mb='12px' />
          <Shimmer height='20px' width='55%' />
        </Card>
      ))}
    </Flex>

    {/* Table beside chart, the usual first-row pairing */}
    <Flex gap='16px' flex='1' minH={0}>
      <Card flex='1' display='flex' flexDirection='column' gap='10px'>
        <Shimmer height='12px' width='90px' mb='4px' />
        {Array.from({ length: 6 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Shimmer key={index} height='10px' />
        ))}
      </Card>
      <Card flex='1' display='flex' flexDirection='column'>
        <Shimmer height='12px' width='70px' mb='16px' />
        <Shimmer flex='1' control />
      </Card>
    </Flex>
  </Flex>
);

export default DashboardSkeletonLoader;
